module.exports = __webpack_public_path__ + "img/phone.svg?d30a4036107f68bbde8b31080b0b667e";